import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

//styles
import { Dropdown } from './Dropdown.styled';

export const customDropdownStyles = {
  option: (styles, additionalProps) => {
    const { isFocused } = additionalProps;

    return {
      ...styles,
      cursor: 'pointer',
      color: '#25282B',
      '&:active': {
        backgroundColor: '#ededed',
      },
      backgroundColor: isFocused ? '#ededed' : null,
    };
  },
};

const CustomDropdown = ({
  error,
  options,
  defaultValue,
  setFieldValue,
  name,
  disabled,
  value,
  onChange = undefined,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Dropdown
      styles={customDropdownStyles}
      defaultValue={defaultValue}
      options={options}
      classNamePrefix="true"
      placeholder={t('Select...')}
      onChange={option => {
        if (!!onChange) {
          onChange(option);
        }
        if (!!setFieldValue) {
          setFieldValue(name, option);
        }
      }}
      error={error ? 'hasError' : 'noError'}
      isDisabled={disabled} // react-select prop, don't change!
      isLoading={isLoading}
      value={value}
      name={name}
    />
  );
};

CustomDropdown.propTypes = {
  error: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    }),
  ),
  defaultValue: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  }),
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  }),
};

export default CustomDropdown;
